import script from "./Loading.vue?vue&type=script&lang=ts&setup=true"
export * from "./Loading.vue?vue&type=script&lang=ts&setup=true"

import "./Loading.vue?vue&type=style&index=0&id=4e4767fb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e4767fb"]])

export default __exports__